// removed by extract-text-webpack-plugin
module.exports = {"base":"EmptyList_base--3MWax","holder":"EmptyList_holder--y73hL","title":"EmptyList_title--2F3U_","message":"EmptyList_message--DrWgO","button":"EmptyList_button--21m3j"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-mt-bootstrap/lib/components/EmptyList/EmptyList.css
// module id = 1776
// module chunks = 16